import { createUseStyles } from "react-jss";
import { ITheme } from "../../constants/theme";
import { BreakPointDesktop } from "../../constants/dimension";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    minHeight: "100vh",
    boxSizing: "border-box",
  },
  rootContent: {
    height: "100%",
    overflow: "initial",
    scrollbarWidth: "none",
    contain: "layout",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    zIndex: 2,
    gap: theme.spacing.space16,
    [BreakPointDesktop]: {
      gap: 44,
    },
  },
}));
